import React, { useEffect, useState} from "react";
import { getDomainConfig } from "../../config/config";

const StandardButton = (props) => {

const config = getDomainConfig();

/* LOADING THE BRANDED SCSS */
const [styles, setStyles] = useState(false);

useEffect(() => {

const getStyles = async (theFileName, theFileEnd) => {
  if (config.brand) {
    let moduleStyles = false;
    try {
      moduleStyles = await import(
        "./" + theFileName + config.brand + theFileEnd
      );
      setStyles(moduleStyles);
    } catch (e) {
      console.error(
        `Styles for ${theFileName} could not be loaded, ${e.message}`
      );
    }
  }
};

  // Specify file name and end of file name here.
  getStyles("StandardButton", ".module.scss");
}, [config.brand]);

/* END LOADING THE BRANDED SCSS */

  const propsId = props.id; // May have come through from props
  const propsclick = props.onClick // May have come through from props
  const propsName = props.name; // May have come through from props
  const propsValue = props.value; // May have come through from props
  const propsType = props.type; // May have come through from props
  const disabled = props.disabled;
  let defaultClass = styles.button; // The generic class (in css modules format)
  let classes = defaultClass; // The classes list to show

  if (props.loading) {
    classes = classes + ' ' + styles.loading;
  }

  if (props.className) { // If any extra classes come through via props, turn them into css modules format too
    classes = classes + ' ' + props.className.split(' ').map(thisStyle => {
      return styles[thisStyle];
    }).join(' ');
  }

  return (
    <button
    id={propsId}
    className={classes}
    onClick={propsclick}
    name={propsName}
    value={propsValue}
    type={propsType}
    disabled={disabled}
  >
    {props.children}
  </button>
  );
};

export default StandardButton;
